import { render, staticRenderFns } from "./WhitelabelLandingComforters.vue?vue&type=template&id=0dc7464e&scoped=true&"
import script from "./WhitelabelLandingComforters.vue?vue&type=script&lang=js&"
export * from "./WhitelabelLandingComforters.vue?vue&type=script&lang=js&"
import style0 from "./WhitelabelLandingComforters.vue?vue&type=style&index=0&id=0dc7464e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc7464e",
  null
  
)

export default component.exports